import styled from 'styled-components';
import type { StripProps } from '../types';

export const Strip = styled.div<StripProps>`
  width: ${({ percentage }) => `${percentage}%`};
  background: ${({ theme, color }) => theme.colors[color]};
  height: 100%;
  border: 0.5px solid ${({ theme }) => theme.colors.white};
`;
